"use client";

import PropTypes from "prop-types";

import { formatPhoneView, phoneMasking } from "src/utils/ui";

import Title from "components/listing-detail/title";
import MoreContent from "components/listing-detail/more-content";

import styles from "./styles.module.css";

const Description = ({ data, jethat, listingId }) => {
  let desc = data;
  const numberIndexOf850 = jethat?.indexOf("850");
  const numberIndexOf312 = jethat?.indexOf("312");

  if (
    jethat &&
    ((numberIndexOf850 >= 0 && numberIndexOf850 <= 5) || (numberIndexOf312 >= 0 && numberIndexOf312 <= 5))
  ) {
    const phoneNumber = jethat.startsWith("+9") ? jethat.split("+9")[1] : jethat;
    const formattedJetHat = formatPhoneView(phoneNumber);
    desc = phoneMasking(desc, formattedJetHat, listingId);
  }

  const cleanedDescription = desc.replace(/<(h[1-3])[^>]*>([\s\S]*?)<\/\1>/g, (match, tag, content) => {
    let fontSize;
    let marginBlockStart;
    let marginBlockEnd;

    switch (tag) {
      case "h1":
        fontSize = "2em";
        marginBlockStart = "0.67em";
        marginBlockEnd = "0.67em";

        break;
      case "h2":
        fontSize = "1.5em";
        marginBlockStart = "0.83em";
        marginBlockEnd = "0.83em";

        break;
      case "p":
        fontSize = "1.17em";
        marginBlockStart = "1em";
        marginBlockEnd = "1em";

        break;
    }

    return `<span style="display:block; margin-block-start: ${marginBlockStart};margin-block-end: ${marginBlockEnd}; font-size: ${fontSize}; font-weight: bold;">${content}</span>`;
  });

  const removeSecondHtmlBody = (str) => {
    const matches = [...str.matchAll(/<(html|body)[^>]*>[\s\S]*?<\/\1>/g)];
    if (matches.length > 0) {
      const secondMatch = matches[0];
      const contentInsideSecondHtmlBody = secondMatch[0].replace(/<\/?(html|body)[^>]*>/g, "");
      return str.replace(secondMatch[0], contentInsideSecondHtmlBody);
    }
    return str;
  };

  const cleanedDescriptionWithoutSecondHtmlBody = removeSecondHtmlBody(cleanedDescription);

  return (
    <div className={styles.wrapper}>
      <Title>İlan Açıklaması</Title>
      <MoreContent defaultHeight={251}>
        <div className={styles.inner} dangerouslySetInnerHTML={{ __html: cleanedDescriptionWithoutSecondHtmlBody }} />
      </MoreContent>
    </div>
  );
};

Description.propTypes = {
  data: PropTypes.string,
  jethat: PropTypes.string,
  listingId: PropTypes.number,
};

export default Description;
